import styled from '@emotion/styled';
import { Button, Snackbar as _Snackbar } from '@material-ui/core';
import { SnackbarOrigin } from '@material-ui/core/Snackbar';
import { SyntheticEvent, FC } from 'react';
import { SnackbarContentProps } from '@material-ui/core/SnackbarContent';

type Props = {
  anchorOrigin?: SnackbarOrigin;
  autoHideDuration?: number;
  message: string | null;
  action?: string;
  severity?: 'default' | 'error' | 'warning' | 'information' | 'success' | 'init';
  buttonColor?: 'default' | 'inherit' | 'primary' | 'secondary';
  onClickAction?: (e: SyntheticEvent<HTMLElement>) => void;
  onRequestClear: (e: SyntheticEvent<HTMLElement>) => void;
  className?: string;
  ContentProps?: Partial<SnackbarContentProps>;
};

const CustomSnackbar: FC<Props> = ({
  anchorOrigin,
  autoHideDuration,
  message,
  action,
  buttonColor = 'default',
  severity = 'default',
  onClickAction,
  onRequestClear,
  className,
  ContentProps,
}) => (
  <Snackbar
    severity={severity}
    anchorOrigin={anchorOrigin}
    autoHideDuration={autoHideDuration}
    open={!!message}
    message={message ? <span>{message}</span> : undefined}
    action={
      action ? (
        <Button color={buttonColor} size="small" onClick={onClickAction}>
          <Message>{action}</Message>
        </Button>
      ) : undefined
    }
    onClose={onRequestClear}
    className={className}
    ContentProps={ContentProps}
  />
);

const Message = styled('span')({ wordBreak: 'break-all', color: 'inherit' });

const Snackbar = styled(_Snackbar)<{ severity: 'default' | 'error' | 'warning' | 'information' | 'success' | 'init' }>(
  (props) => {
    return {
      zIndex: 2147483000 + 1, // 2147483000 is intercomIcon
      '& > .MuiSnackbarContent-root': {
        // snackbarを上書きする際、一瞬initial stateで定義したseverityのbackground-colorが表示される為initのenum stringを追加して背景をunsetしている
        ...(props.severity === 'init' && {
          backgroundColor: 'unset',
        }),
        ...(props.severity === 'error' && {
          backgroundColor: '#FE7877',
        }),
        ...(props.severity === 'warning' && {
          backgroundColor: '#FCB100',
        }),
        ...(props.severity === 'information' && {
          backgroundColor: '#5FA9FF',
        }),
        ...(props.severity === 'success' && {
          backgroundColor: '#2DCC70',
        }),
      },
    };
  },
);

export default CustomSnackbar;
